"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { SITE_TITLE } from "@/lib/metadata/site";

/**
 * Keeps `document.title` unified on client navigations (defense in depth with root metadata).
 */
export function SiteDocumentTitle() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof document === "undefined") return;
    if (document.title !== SITE_TITLE) {
      document.title = SITE_TITLE;
    }
  }, [pathname]);

  return null;
}
